module.exports = __webpack_public_path__ + "img/fig14.da0b9bb6.jpg";